export default "__VITE_ASSET__DtpkrqPX__"